import React, { useEffect, useContext } from 'react';
import { ProductContext } from '../../ProductProvider';
import ProfileImage from '../../components/profile/ProfileImage';
import { Helmet } from 'react-helmet-async';

const modernProfileStyles = `
  .profile-modern-card {
    background: linear-gradient(135deg, #f8fafc 60%, #e0e7ff 100%);
    border-radius: 18px;
    box-shadow: 0 4px 24px 0 rgba(80, 80, 120, 0.10);
    padding: 2.5rem 2rem 2rem 2rem;
    margin: 0 auto 2.5rem auto;
    max-width: 520px;
    position: relative;
    z-index: 1;
  }
  .profile-modern-header {
    text-align: center;
    font-weight: 700;
    font-size: 1.5rem;
    margin-bottom: 1.2rem;
    letter-spacing: 0.5px;
    color: #3b3b6d;
  }
  .profile-modern-img {
    display: flex;
    justify-content: center;
    margin-bottom: 1.2rem;
  }
  .profile-modern-fields {
    display: flex;
    flex-wrap: wrap;
    gap: 1.2rem 2%;
    margin-top: 0.5rem;
  }
  .profile-modern-field {
    flex: 1 1 48%;
    min-width: 180px;
    display: flex;
    flex-direction: column;
    margin-bottom: 0.5rem;
  }
  .profile-modern-label {
    font-size: 1rem;
    font-weight: 500;
    color: #6366f1;
    margin-bottom: 0.2rem;
    margin-left: 2px;
  }
  .profile-modern-input {
    background: #fff;
    border: 1.5px solid #c7d2fe;
    border-radius: 7px;
    font-size: 1.05rem;
    padding: 0.7rem 1rem;
    color: #3b3b6d;
    font-weight: 500;
    margin-bottom: 0.1rem;
    outline: none;
    transition: border 0.18s cubic-bezier(.4,0,.2,1);
    width: 100%;
    box-sizing: border-box;
  }
  .profile-modern-input:focus {
    border: 1.5px solid #6366f1;
    background: #f1f5ff;
  }
  @media (max-width: 900px) {
    .profile-modern-card {
      max-width: 98vw;
      padding: 1.5rem 0.7rem 1.2rem 0.7rem;
    }
    .profile-modern-header {
      font-size: 1.15rem;
    }
    .profile-modern-fields {
      gap: 0.7rem 0;
    }
    .profile-modern-field {
      min-width: 100%;
      flex: 1 1 100%;
    }
    .profile-modern-input {
      font-size: 0.98rem;
      padding: 0.6rem 0.7rem;
    }
  }
  @media (max-width: 480px) {
    .profile-modern-card {
      padding: 0.7rem 0.2rem 0.7rem 0.2rem;
    }
    .profile-modern-header {
      font-size: 1rem;
    }
  }
`;

export default function MyProfile() {
  const { validateLogin, loggedUser, myProfileImage } = useContext(ProductContext);

  useEffect(() => {
    if (!loggedUser.isAuthenticated) {
      validateLogin();
    }
  }, [loggedUser]);

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(120deg, #f1f5ff 60%, #e0e7ff 100%)', padding: '24px 0' }}>
      <Helmet>
        <title>My Profile - Inigo Library - Arul Kadal - Chennai</title>
        <meta name="description" content="My Profile - Inigo Library - Arul Kadal - Chennai" />
        <meta name="keywords" content="My Profile - Inigo Library - Arul Kadal - Chennai" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <style>{modernProfileStyles}</style>
      <div className="profile-modern-card">
        <div className="profile-modern-header">{loggedUser.name}&apos;s Profile</div>
        <div className="profile-modern-img">
          <ProfileImage profileImage={myProfileImage} />
        </div>
        <div className="profile-modern-fields">
          <div className="profile-modern-field">
            <label className="profile-modern-label">Name</label>
            <input name="name" type="text" className="profile-modern-input" id="name" placeholder="Full Name" required value={loggedUser.name} readOnly />
          </div>
          <div className="profile-modern-field">
            <label className="profile-modern-label">Email Address</label>
            <input name="email" type="email" className="profile-modern-input" id="email" placeholder="E-Mail Address" required value={loggedUser.email} readOnly />
          </div>
          <div className="profile-modern-field">
            <label className="profile-modern-label">Phone No</label>
            <input name="phoneno" type="text" className="profile-modern-input" id="phoneno" placeholder="Phone No" required value={loggedUser.phone_number} readOnly />
          </div>
          {/*<div className="profile-modern-field">
            <label className="profile-modern-label">Registration Number</label>
            <input name="regno" type="text" className="profile-modern-input" id="regno" placeholder="Registration Number" required value={loggedUser.nickname} readOnly />
          </div>*/}
          <div className="profile-modern-field">
            <label className="profile-modern-label">Profile</label>
            <input name="profile" type="text" className="profile-modern-input" id="profile" placeholder="Profile" required value={loggedUser.profile} readOnly />
          </div>
        </div>
      </div>
    </div>
  );
}
